import React from "react";
import { AgGridReact } from "@jsq/ds/core";
import { formatDateWithDefaultUtc } from "../../../../utils/date_formatter";
import { PositionName } from "../../../common/PositionName";
import { TypedAGGridCellRenderParams } from "../../../common/types";
import { RiskRatingGridCell } from "../../../riskRating/RiskRatingGridCell";
import { customRendererCell } from "../styles_vanilla.css";
import { fillCell, inLabel } from "./styles_vanilla.css";
import type { PositionRowData } from "../types";

type PositionColumnDefsOptions = {
  positionNameMap: Map<string, string>;
};

export const getPositionColumnDefs = ({
  positionNameMap,
}: PositionColumnDefsOptions): AgGridReact.AgGridReactProps["columnDefs"] => {
  const positionIds = Array.from(positionNameMap.keys());

  return [
    {
      field: "investorName",
      headerName: "Position",
      pinned: true,
      minWidth: 300,
      sortable: true,
      sort: "asc",
      filter: "agSetColumnFilter",
      filterParams: {
        values: positionIds,
        valueFormatter: ({ value }: { value: string }) => positionNameMap.get(value) ?? value,
        caseSensitive: false,
      },
      menuTabs: ["filterMenuTab", "generalMenuTab", "columnsMenuTab"],
      cellClass: customRendererCell,
      cellRenderer: (params: TypedAGGridCellRenderParams<PositionRowData>) => (
        <PositionName
          account={params.data.investorName}
          entity={params.data.entityName}
          nameVariant="strong-md"
          inVariant="secondary-md"
          inClassName={inLabel}
          truncate
        />
      ),
    },
    {
      field: "complianceStatus",
      headerName: "AML/KYC status",
      flex: 1,
      minWidth: 140,
      sortable: false,
    },
    {
      field: "riskRating",
      headerName: "Risk rating",
      flex: 1,
      minWidth: 120,
      sortable: false,
      cellClass: fillCell,
      cellRenderer: (params: TypedAGGridCellRenderParams<PositionRowData>) => (
        <RiskRatingGridCell rating={params.data.riskRating} />
      ),
    },
    {
      field: "screeningStatus",
      headerName: "Screening status",
      flex: 1,
      minWidth: 140,
      sortable: false,
    },
    {
      field: "onboardingDate",
      headerName: "Onboarding date",
      flex: 1,
      minWidth: 130,
      sortable: false,
      valueFormatter: ({ value }) => formatDateWithDefaultUtc(value),
    },
    {
      field: "lastActivity",
      headerName: "Last activity",
      flex: 1,
      minWidth: 130,
      sortable: false,
      valueFormatter: ({ value }) => formatDateWithDefaultUtc(value),
    },
  ];
};
